import { render, staticRenderFns } from "./TentForm.vue?vue&type=template&id=a5a224c0&scoped=true"
import script from "./TentForm.vue?vue&type=script&lang=ts"
export * from "./TentForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a224c0",
  null
  
)

export default component.exports